import { ApiPromise } from '@/types';
import { AttachmentFileConfig, SendMessagePayload } from '@/types/MessageCenter';
import { HTTP } from '@/utils';

export default class MessageCenterService {
  static chat_resource = 'message-center/chats';
  static message_resource = 'message-center/messages';

  static getChats(): ApiPromise {
    return HTTP.get(`${this.chat_resource}`);
  }

  static deleteChat(id: number): ApiPromise {
    return HTTP.delete(`${this.chat_resource}/${id}`);
  }

  static getAvailableMembers(search: string): ApiPromise {
    return HTTP.get(`message-center/available-members?search=${search}`);
  }

  static createNewChat(payload: FormData): ApiPromise {
    return HTTP.post(`${this.chat_resource}`, payload);
  }

  static getMessages(chatId: number, page: number): ApiPromise {
    return HTTP.get(`${this.message_resource}/${chatId}?page=${page}`);
  }

  static sendMessage(chatId: number, payload: SendMessagePayload | FormData): ApiPromise {
    return HTTP.post(`${this.message_resource}/${chatId}`, payload);
  }

  static deleteMessage(messageId: number): ApiPromise {
    return HTTP.delete(`${this.message_resource}/${messageId}`);
  }

  static deleteMessageFile(messageId: number, documentId: string): ApiPromise {
    return HTTP.delete(`${this.message_resource}/${messageId}/${documentId}`);
  }

  static getMessageSettings(): ApiPromise {
    return HTTP.get('message-center/settings');
  }

  static updateMessageSettings(payload: AttachmentFileConfig): ApiPromise {
    return HTTP.put('message-center/settings', payload);
  }

  static downloadAttachmentStream(messageId: number, documentId: string): ApiPromise {
    return HTTP.get(`${this.message_resource}/${messageId}/files/${documentId}`, {
      responseType: 'blob',
    });
  }
}
